<template>
  <div>
    <el-dialog :title="title" :visible="visible" :width="width" @close="close">
      <div class = "flexRow" style="flex-wrap:wrap">
        <div class = "flexRow" style="margin:0px 10px 10px 10px">
          <div class = "conditionsFont">关键字：</div>
          <el-input v-model="keywords" style="width:200px" placeholder="商品名称、编码"></el-input>
        </div>
        <div class = "flexRow" style="margin:0px 10px 10px 10px">
          <div class = "conditionsFont">销售类型：</div>
          <el-select v-model="state" style="width:200px">
            <el-option v-for="(v,i) in statelist" :key="i" :value="v.value" :label="v.label"></el-option>
          </el-select>
        </div>
        <div class = "flexRow" style="margin:0px 10px 10px 10px">
          <div class = "conditionsFont">商品分组：</div>
          <el-select v-model="group" style="width:200px">
            <el-option :value="null" label="全部"></el-option>
            <el-option v-for="(v,i) in grouplist" :key="i" :value="v.Id" :label="v.GroupName"></el-option>
          </el-select>
        </div>
        <div class = "flexRow" style="margin:0px 10px 10px 10px">
          <div class = "conditionsFont">商品品牌：</div>
          <el-select v-model="brand" style="width:200px">
            <el-option :value="null" label="全部"></el-option>
            <el-option v-for="(v,i) in brandlist" :key="i" :value="v.Id" :label="v.BrandName"></el-option>
          </el-select>
        </div>
        <el-button style="width:90px;height:36px" type="primary" @click="query">查询</el-button>
      </div>
      <div style="margin-top:10px">
        <el-table :data="tablelist" v-loading="tableloading" max-height="500px"  ref="table"  :row-key="rowKeys" @selection-change = "selectionChange">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column prop="CouponName" label="商品" width="220px">
            <template slot-scope="scope">
              <div class = "flexRow rowbetween">
                <img :src="imgUrl+scope.row.ImgUrl" style="width:60px;height:60px" alt="">
                  <div class = "vertical2" style="width:150px;margin-left:5px">
                    {{scope.row.Name}}
                  </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ProductType" label="销售类型">
            <template slot-scope="scope">
              {{scope.row.ProductType==0?'单品销售':'组合销售'}}
            </template>
          </el-table-column>
          <el-table-column prop="Spce" label="规格" width="100px">
            <template slot-scope="scope">
              <div class = "vertical2" style="width:100%">
                {{scope.row.Spce?scope.row.Spce:'默认规格'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Price" label="价格"></el-table-column>  
          <el-table-column prop="Stock" label="库存"></el-table-column>
          <el-table-column prop="Remark" label="备注"></el-table-column>
        </el-table>
      </div>
      <div style="margin-top:10px" class = "flexRow between">
        <el-checkbox :value="allcheck" style="margin-left:15px" @change="checkall">当前页全选</el-checkbox>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="sizepage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div style="text-align:center;margin-top:20px">
        已选中 <span style="color:#f56c6c">{{checklist.length}}</span> 件
        <el-button type="primary" style="width:90px;height:36px;margin-left:15px" @click="couponsconfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/config"
import {
  productSpecpopList,
  productGroupfilterBoxList,
  productBrandfilterBoxList
} from "@/api/sv1.0.0"
export default {
  props:{
    title:{
      type:String,
      default:'选择赠品'
    },
    visible:{
      type:Boolean,
      default:false
    },
    width:{
      type:String,
      default:'70%'
    },
    thelist:{
      type:Array,
      default:()=>{
        return []
      }
    },
  },
  data () {
    return {
      imgUrl: config.IMG_BASE,
      keywords:'',
      state:null,
      statelist:[
        {value:null,label:'全部'},
        {value:0,label:'单品销售'},
        {value:1,label:'组合销售'},
      ],
      group:null,
      grouplist:[],
      brand:null,
      brandlist:[],

      tablelist:[],
      tableloading:false,
      // allcheck:false,
      checklist:[],

      currentPage:1,
      sizepage:10,
      total:null,
      iseffective:false
    }
  },
  watch:{
    visible(val){
      if(val){
        // console.log(this.thelist)
        this.getgroup()
        this.getbrand()
        this.gettablelist()
        this.iseffective = true
        this.$nextTick(()=>{
          // console.log()
          this.thelist.map((x)=>{
            x.ProductSpecId=x.GiftProductSpecId
            x.ProductId = x.GiftProductId
            this.$refs.table.toggleRowSelection(x,true)
          })
        })
      }
    },
  },
  computed:{
    allcheck(){
      if(this.tablelist&&this.tablelist.length){
        return this.tablelist.every((v)=>{
          return this.checklist.some((x)=>{
            return v.ProductSpecId == x.ProductSpecId
          })
        })
      }
    },
  },
  methods: {
    close(){

      // this.visible = false
      this.keywords = ''
      this.state = null
      this.currentPage = 1
      this.sizepage = 10
      this.iseffective = false
      this.$refs.table.clearSelection()
      this.$emit('close')
    },
    couponsconfirm(){
      // console.log(this.checklist)
      this.$emit('confirm',this.checklist)
    },
    query(){
      this.currentPage = 1
      this.gettablelist()
    },
    rowKeys(row) {
      // console.log(row)
			return row.ProductSpecId
		},
    selectionChange(e){
      this.checklist = e
    },
    checkall(){
      this.$refs.table.toggleAllSelection()
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.sizepage = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    //分组
    async getgroup(){
      let result = await productGroupfilterBoxList()
      if(result.IsSuccess){
        // console.log(result.Result)
        this.grouplist = result.Result
      }
    },
    async getbrand(){
      let result = await productBrandfilterBoxList()
      if(result.IsSuccess){
        //  console.log(result.Result)
        this.brandlist = result.Result
      }
    },
    async gettablelist(){
      this.tableloading = true
      try{
        let data = {
          KeyWord:this.keywords,
          ProductType:this.state,
          ProductGroupIds:this.group,
          ProductBrandId:this.brand,
          Skip:(this.currentPage-1)*this.sizepage,
          Take:this.sizepage
        }
        let result = await productSpecpopList(data)
        if(result.IsSuccess){
          this.tablelist = result.Result.Results
          this.total = result.Result.Total
          // if(this.iseffective){
          //   this.$nextTick(()=>{
          //     this.thelist.map((x)=>{
          //       x.ProductSpecId=x.GiftProductSpecId
          //       x.ProductId = x.GiftProductId
          //       this.tablelist.map((v)=>{
          //         if(x.GiftProductSpecId==v.ProductSpecId){
          //           this.$refs.table.toggleRowSelection(v,true) 
          //         }
          //       })    
          //     })
          //     this.iseffective = false
          //   })
          // }
        }
      }finally{
        this.tableloading = false
      }
    },
  }
}
</script>

<style lang = "less" scoped>
  .flexRow{
    display: flex;
    flex-direction: row;
  }
  .conditionsFont{
    font-size: 14px;
    line-height: 36px;
    font-weight: bold;
    color: #606266;
  }
  .between{
    justify-content: space-between;
  }
  .rowbetween{
    justify-content: space-between;
    align-items: center;
  }
  .vertical2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
</style>